<header>
    <div class="d-flex">
        <button kendoButton class="button" (click)="fileInput.click()" [disabled]="isOpenDocumentButtonDisabled">{{'document.select-file' | translate}}</button>
        <button kendoButton class="button" *ngIf="isTemplateDownloadButtonVisible" [disabled]="isDisabled" (click)="onTemplateDownloadDocumentClick()">{{'document.downloadTemplate' |translate}}</button>
    </div>
    <input style="display:none" #fileInput type="file" onclick="value = null" (change)="onFileUploadChange($event)" [accept]="acceptedFileFormats">
    <div class="d-flex align-items-center">
        <kendo-label class="form-label" translate>document.allowedFileFormats</kendo-label>
        <span class="text-xs">{{acceptedFileFormats}}</span>
    </div>
</header>
<main>
    <div *ngIf="filteredDocuments.length" class="items-header py-2 px-2">
        <div class="form-label text-sm" translate>document.name</div>
        <div class="form-label text-sm"  translate>document.size</div>
        <div class="buttons"
            [class]="{ 'justify-content-between': showHerkunftsnachweisHeader, 'justify-content-end': ! showHerkunftsnachweisHeader }">
            <div *ngIf="showHerkunftsnachweisHeader" class="herkunftsnachweis" translate>document.copyright</div>
            <div class="form-label text-sm" translate>document.actions</div>
        </div>
    </div>
    <document-view-item [disabled]="isDisabled" class="document-view-item"
        [class]="documentStatus == 0 ? 'opacity-25' : ''" *ngFor="let document of filteredDocuments; let index = index;"
        [(ngModel)]="filteredDocuments[index]" [documents]="documents" [paymentId]="paymentId"
        [originalDocuments]="originalDocuments" (documentDelete)="onDocumentDelete(filteredDocuments[index])">
    </document-view-item>
    <span class="form-label pt-8 pb-8 no-entry-message d-flex justify-content-center" *ngIf="isNoEntryMessageVisible"  translate>document.noEntryMessage</span>
</main>